import { Button } from "../../../../../../../components/ui";
import useUser from "../../../../../../../hooks/useUser";
import AddSalesPerson from "./AddSalesPerson";
import { summariseMatchedSalesPeople } from "./matchedSalesPeopleSummary";

const STATUS_CLASSES = {
  info: "text-gray-700",
  warning: "font-medium text-amber-700",
};

const MatchedSalesPeople = props => {
  const { invoice, matchedSalesPeople } = props;
  const { hasPermission } = useUser();
  const invoiceSalesPeople = invoice?.invoiceSalesPersons;
  const summary = summariseMatchedSalesPeople(
    Array.isArray(invoiceSalesPeople) && matchedSalesPeople
      ? {
          ...matchedSalesPeople,
          invoiceHasSalesPeople: invoiceSalesPeople.length > 0,
        }
      : matchedSalesPeople,
    { canEdit: hasPermission("UPDATE_INVOICE_SALES_PERSON") },
  );

  if (!summary) return null;

  return (
    <div
      className="rounded border border-gray-300 bg-gray-50 p-4 text-sm"
      data-testid="matched-sales-people"
    >
      <div className="font-bold">Sales people from this sale</div>
      <ul className="mt-2 list-disc pl-5">
        {summary.sections.map(section => (
          <li key={section}>{section}</li>
        ))}
      </ul>
      <p className={`mt-2 ${STATUS_CLASSES[summary.status.tone]}`}>
        {summary.status.message}
      </p>
      {summary.canAddToExisting && (
        <div className="mt-2">
          <AddSalesPerson
            invoice={invoice}
            additionalSalesPeople={matchedSalesPeople.salesPeople}
            trigger={<Button action="default" label="Add to sales people" />}
          />
        </div>
      )}
      <details className="mt-2 text-xs text-gray-500">
        <summary className="cursor-pointer">How these were matched</summary>
        <ul className="mt-1 list-disc pl-5">
          {summary.criteria.map(criterion => (
            <li key={criterion}>{criterion}</li>
          ))}
        </ul>
      </details>
    </div>
  );
};

export default MatchedSalesPeople;
